module.exports = __webpack_public_path__ + "img/filters-ductwork-cleaned-02-tablet.e7870a6f.jpg";